<div class="w-full">
  <mat-form-field class="w-full" *ngIf="!value; else valueSelected">
    <mat-label>Address search</mat-label>
    <input matInput placeholder="Search" [formControl]="searchField" [matAutocomplete]="auto" (onBlur)="onTouched()" />
    <mat-icon matSuffix>search</mat-icon>
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="selectAddress($event)">
      @if ((status$ | async) === 'no results' && searchField.value) {
      <mat-option [value]="null">
        <p class="text-center text-sm text-gray-500 italic">No results found</p>
      </mat-option>
      }
      @if ((status$ | async) === 'loading') {
      <mat-option [value]="null">
        <p class="text-center text-sm text-gray-500 italic">Loading...</p>
      </mat-option>
      }
      @if ((status$ | async) === 'idle') {
      @for (option of searchResults$ | async; track option.place_id) {
      <mat-option [value]="option">{{ option.address }}</mat-option>
      }
      }
    </mat-autocomplete>
    <mat-error *ngIf="hasError">{{ errorMessage }}</mat-error>
  </mat-form-field>
  <ng-template #valueSelected>
    <div class="flex flex-row w-full justify-start items-center">
      <mat-form-field class="w-full">
        <mat-label>Address</mat-label>
        <input matInput [value]="value.address" disabled />
      </mat-form-field>
      <button mat-icon-button (click)="clearSelected()">
        <mat-icon>clear</mat-icon>
      </button>
    </div>
  </ng-template>
</div>